
<h2 class="govuk-heading-l">Contact</h2>

<p class="govuk-body">{{data?.contactText}}</p>

<ng-container *ngIf="contact; else noContact">

  <!-- Summary List: https://design-system.service.gov.uk/components/summary-list/ -->
  <dl class="govuk-summary-list">

    <!-- Self Referral Url -->
    <div class="govuk-summary-list__row" *ngIf="contact.selfReferralUrl">
      <dt class="govuk-summary-list__key">Online</dt>
      <dd class="govuk-summary-list__value"><a [href]="contact.selfReferralUrl">Self Referral Service</a></dd>
    </div>

    <!-- Telephone -->
    <div class="govuk-summary-list__row" *ngIf="contact.telephone">
      <dt class="govuk-summary-list__key">Telephone</dt>
      <dd class="govuk-summary-list__value">{{contact.telephone}}</dd>
    </div>

    <!-- Email -->
    <div class="govuk-summary-list__row" *ngIf="contact.email">
      <dt class="govuk-summary-list__key">Email</dt>
      <dd class="govuk-summary-list__value"><a href="mailto:{{contact.email}}">{{contact.email}}</a></dd>
    </div>

    <!-- Information -->
    <div class="govuk-summary-list__row" *ngIf="contact.information">
      <dt class="govuk-summary-list__key">Information</dt>
      <dd class="govuk-summary-list__value white-space-pre">{{contact.information}}</dd>
    </div>

    <!-- Emergency -->
    <div class="govuk-summary-list__row" *ngIf="contact.emergencyContact">
      <dt class="govuk-summary-list__key">Out of Hours Emergency</dt>
      <dd class="govuk-summary-list__value white-space-pre">{{contact.emergencyContact}}</dd>
    </div>

    <!-- Translation -->
    <div class="govuk-summary-list__row" *ngIf="contact.translationUrl">
      <dt class="govuk-summary-list__key">Translation</dt>
      <dd class="govuk-summary-list__value"><a [href]="contact.translationUrl">Translation Service</a></dd>
    </div>

    <!-- Address -->
    <div class="govuk-summary-list__row" *ngIf="contact.address">
      <dt class="govuk-summary-list__key">Address</dt>
      <dd class="govuk-summary-list__value white-space-pre">{{contact.address}}</dd>
    </div>
  </dl>

</ng-container>

<ng-template #noContact>
  <p class="govuk-body">No information available</p>
</ng-template>

<a routerLink="/questions" role="button" draggable="false"  class="noprint govuk-button govuk-button--start govuk-!-margin-top-2 theme-button">
  Get more advice
</a>
